import * as Bowser from "bowser"

export const userAgent = window.navigator.userAgent
const parser = Bowser.getParser(userAgent)
export const isIE = parser.is("internet explorer")
export const isEdge = parser.is("edge")
export const isIEOrEdge = isIE || isEdge
export const isFirefox = parser.is("firefox")
export const isChrome = parser.is("chrome")

export function isBrowserOutdated(): boolean | undefined {
    return parser.satisfies({
        ie: "<11",
        firefox: "<4",
        safari: "<5.0.2",
        // The userAgent string for Edge provides use with the EdgeHTML version, not Edge itself
        // See [https://github.com/lancedikson/bowser/issues/203 ] for more info.
        edge: "<12.10166", // edgeHTML version number for edge 20
        chrome: "<8",
    })
}
